import React, {Component} from "react"
import {observer} from "mobx-react"
import {Segment, Dimmer, Loader, Divider, Button, Icon} from "semantic-ui-react"
import {withRouter} from "react-router-dom"
import api from "../api"

import SignaturesOverview from "./components/SignaturesOverview"

const { signatureStore } = api
import { withTranslation, Trans } from 'react-i18next'

import SignatureDialog from "./components/SignatureDialog/SignatureDialog"
import TopNavigation from "./components/TopNavigation"
import OrderSummary from "./components/OrderSummary"

@observer
class SignPage extends Component {
  constructor() {
    super()
    let order  = api.getOrder()
    this.state = {
      order, loading: true,
    }

    api.loadOrder( order.Id )
      .then( order => {
        this.setState( { order, loading: false } )
      } )
  }

  render() {
    let { order, loading }               = this.state
    const { signatures, signaturesOpen } = signatureStore
    const { t } = this.props;

    return (
      <div>
        <TopNavigation/>
        {signaturesOpen.length && <div>
          <Segment inverted color="red">
            <div className="tc">
              <Trans t={t} i18nKey="signature.missing">
                Zur Übertragung fehlen noch {signaturesOpen.length} Unterschriften
              </Trans>
            </div>
          </Segment>
        </div>}
        {signaturesOpen.length && <div className="pv3"><SignaturesOverview signatures={signatures}/></div>}

        {!signaturesOpen.length && <div className="transition-item">
          <Dimmer.Dimmable dimmed={loading}>
            <Dimmer active={loading} inverted>
              <Loader>{t("general.loading")}</Loader>
            </Dimmer>
            <div className="section-full section--center">
              <OrderSummary order={order}/>
              <Segment basic textAlign="center">
                <SignSubcontractor/>
              </Segment>
            </div>
          </Dimmer.Dimmable>
        </div>}
      </div>
    )
  }
}

class SignSubcontractor extends Component {

  constructor() {
    super()
    this.signaturePad = false
    this.state        = {
      isEmpty: true
    }
  }

  loadSignature = ({ signaturePad }) => {
    this.signaturePad = signaturePad
    this.interval     = setInterval( this.dirtyCheck, 300 )
  }

  dirtyCheck = () => {
    let isEmpty = this.signaturePad.isEmpty()
    this.setState( { isEmpty } )
  }

  componentWillUnmount() {
    clearInterval( this.interval )
  }

  postDataUrl(dataUrl) {
    let step = api.getExternalSignatureStep( api.getOrder() )
    if ( !step ) {
      console.error( "Could not find a SignatureStep for external Technician" )
    }
    let file          = dataURLtoBlob( dataUrl )
    let subContractor = api.getSubcontractor()
    let name          = `${subContractor.FirstName} ${subContractor.LastName}`
    file.filename     = "Unterschrift externer Techniker"
    let files         = [ file ]
    return api.postSignature( {
      files, step, name, title: "<Trans t={t} i18nKey=\"general.exttechnician\">ext. Technician</Trans>"
    } )
  }

  handleError = (err) => {
    let { history } = this.props
    window.alert( "<Trans t={t} i18nKey=\"general.error.transmission\">Error while submitting</Trans>" )
    console.error( "Error while submitting", err )
    history.push( "/sign" )
  }

  signAndSend = () => {
    let dataUrl = this.getDataUrl()
    if ( !dataUrl ) {
      console.warn( "no Signature available" )
      return
    }
    let { history } = this.props
    history.push( "/submit" )

    this.postDataUrl( dataUrl )
      .then( () => {
        api._signatureDataUrl = dataUrl
        return api.updateState( "eIsWorkDone" )
          .then( () => {
            return api.updateState( "eIsWorkDone" )
              .then( () => {
              } )
              .catch( this.handleError )
          } )
          .catch( this.handleError )
      } )
      .catch( this.handleError )
  }

  getDataUrl() {
    if ( !this.signaturePad ) {
      console.warn( "Signature Pad not loaded in time" )
      return false
    }

    if ( this.signaturePad.isEmpty() ) {
      console.warn( "Signature Pad is Empty" )
      return false
    }
    return this.signaturePad.toDataURL( "image/jpg" )
  }

  render() {
    let subContractor     = api.getSubcontractor()
    let subContractorName = `${subContractor.FirstName} ${subContractor.LastName}`
    let { isEmpty }       = this.state
    const { t } = this.props;

    return (
      <div>
        <Divider horizontal inverted>{t("signature.add")}</Divider>
        <SignatureDialog setup={this.loadSignature}
                         showNameInput={false}
                         name={subContractorName}/>
        <Divider horizontal inverted>{subContractorName}</Divider>
        <div className="pb4 pt3">
          {isEmpty ? <Button disabled inverted basic>
            {t("job.send")}</Button> : <Button onClick={() => {this.signAndSend()}}
                                                   color="green" icon labelPosition='left'
                                                   size='small'>
            <Icon name='checkmark'/> {t("job.send")}
          </Button>}
        </div>
      </div>
    )
  }
}

export default withTranslation()(SignPage)

const dataURLtoBlob = (dataURL) => {
  let binary = atob( dataURL.split( "," )[ 1 ] )
  let array  = []
  let i      = 0
  while ( i < binary.length ) {
    array.push( binary.charCodeAt( i ) )
    i++
  }
  //# Return our Blob object
  return new Blob( [ new Uint8Array( array ) ], { type: "image/png" } )
}
SignSubcontractor = withRouter( SignSubcontractor )
SignSubcontractor = withTranslation()(SignSubcontractor)





// WEBPACK FOOTER //
// ./src/pages/SignPage.js